/**
 * Asynchronously loads the component for PassengerInfo
 */

import { lazyLoad } from 'utils/loadable';

export const PassengerInfo = lazyLoad(
  () => import('./index'),
  module => module.default,
);
